<template>
    <AppLayout>
        <HomeHeader />
        <HomeFeatures />
        <HomeCategories />
        <HomeStats />
        <HomeTestimonials />
        <HomeFaqs />
        <HomePricing />
        <HomeContact />

        <Dialogable />
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import HomeHeader from '@/components/pages/Home/Header.vue';
import HomeCategories from '@/components/pages/Home/Categories.vue';
import HomeFeatures from '@/components/pages/Home/Features.vue';
import HomeStats from '@/components/pages/Home/Stats.vue';
import HomeTestimonials from '@/components/pages/Home/Testimonials.vue';
import HomeFaqs from '@/components/pages/Home/Faqs.vue';
import HomePricing from '@/components/pages/Home/Pricing.vue';
import HomeContact from '@/components/pages/Home/Contact.vue';
import Dialogable from '@/components/common/Dialogable.vue';
</script>